module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5O1DR"))).then(() => module.bundle.root('hEqeo'));